import "./styles.scss";
import { useTranslation } from "react-i18next";
import { Handle, Position } from "@xyflow/react";
import { IconPlus } from "@tabler/icons-react";
import { Text } from "@fragments";

export default function AddReceiverNode({ data }) {
  const { t } = useTranslation("settings");

  return (
    <div className="split-add-node" onClick={() => data.onAdd?.()}>
      <Handle
        type="target"
        position={Position.Left}
        className="split-flow-handle"
      />

      <div
        className="san-card"
        style={{ animationDelay: `${(data.index ?? 0) * 70}ms` }}
      >
        <Text.h5 left={<IconPlus />} contrast={7}>
          {t("split.flow.addReceiver")}
        </Text.h5>
      </div>
    </div>
  );
}
